
import { RequestedValue$1 } from "../../Shared/Shared.js";
import { Msg, State } from "./Types.js";
import { Cmd_none, Cmd_batch } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { Cmd_OfPromise_either } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../../fable_modules/Fable.Promise.2.0.0/Promise.fs.js";
import { promise } from "../../fable_modules/Fable.Promise.2.0.0/PromiseImpl.fs.js";
import { addPrefix, fetchWithDecoder } from "../../Communication.js";
import { Types_RequestProperties } from "../../fable_modules/Fable.Fetch.2.1.0/Fetch.fs.js";
import { ofArray, singleton } from "../../fable_modules/fable-library-js.5.0.0-rc.2/List.js";
import { Reader_$ctor_Z3F6BC7B1, Reader__Read_24524716 } from "../../fable_modules/Fable.Remoting.MsgPack.1.25.0/Read.fs.js";
import { LocationDetailDto_$reflection } from "../../Shared/Location.js";
import { concat } from "../../fable_modules/fable-library-js.5.0.0-rc.2/String.js";
import { unwrapLocationId } from "../../Shared/Helper.js";
import { Cmd_successToast, Cmd_errorToast } from "../../Components/Toast.js";
import { fetchWithDecoder as fetchWithDecoder_1, addPrefix as addPrefix_1 } from "../../CommunicationV2.js";
import { string_type } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Reflection.js";
import { defaultArg } from "../../fable_modules/fable-library-js.5.0.0-rc.2/Option.js";
import { Cmd_ofEffect } from "../../fable_modules/Fable.Elmish.5.0.2/cmd.fs.js";
import { RouterModule_nav } from "../../fable_modules/Feliz.Router.4.0.0/Router.fs.js";

export function initViewLocationView(locationId) {
    return [new State(new RequestedValue$1(0, [])), Cmd_batch(singleton(Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (fetchWithDecoder(0, addPrefix(url), singleton(new Types_RequestProperties(0, ["GET"])), "application/json", (response) => {
        const pr = response.arrayBuffer();
        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), LocationDetailDto_$reflection()));
    })))), concat("/api/locations/", ...unwrapLocationId(locationId)), (Item) => (new Msg(1, [Item])), (Item_1) => (new Msg(2, [Item_1])))))];
}

export function update(msg, state) {
    switch (msg.tag) {
        case 2:
            return [state, Cmd_errorToast("storage.fail_fetch_data")];
        case 0: {
            const matchValue = state.Location;
            if (matchValue.tag === 0) {
                return [state, Cmd_none()];
            }
            else {
                return [state, Cmd_OfPromise_either((url) => PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
                    let url_2;
                    return ((url_2 = addPrefix_1(url), (refreshOn) => fetchWithDecoder_1(url_2, singleton(new Types_RequestProperties(0, ["DELETE"])), "application/json", (response) => {
                        const pr = response.arrayBuffer();
                        return pr.then((blob) => Reader__Read_24524716(Reader_$ctor_Z3F6BC7B1(new Uint8Array(blob)), string_type));
                    }, refreshOn)))(true);
                })), concat("/api/locations/", ...matchValue.fields[0].Id), (Item) => (new Msg(3, [Item])), (Item_1) => (new Msg(2, [Item_1])))];
            }
        }
        case 3: {
            const response_1 = msg.fields[0];
            if (response_1.tag === 1) {
                return [state, Cmd_errorToast(defaultArg(response_1.fields[0].GlobalValidationMessage, "location.location_deleted_error"))];
            }
            else {
                return [state, Cmd_batch(ofArray([Cmd_ofEffect((_arg) => {
                    RouterModule_nav(singleton("locations"), 1, 1);
                }), Cmd_successToast("location.location_deleted_success")]))];
            }
        }
        default:
            return [new State(new RequestedValue$1(1, [msg.fields[0]])), Cmd_none()];
    }
}

